export default __webpack_public_path__ + "static/media/logo-esta-website.e78f6512.png";